webpackJsonp([169928946856436],{

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundVideo = function (_Component) {
	    _inherits(BackgroundVideo, _Component);
	
	    function BackgroundVideo() {
	        _classCallCheck(this, BackgroundVideo);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BackgroundVideo.prototype.render = function render() {
	        var _props = this.props,
	            src = _props.src,
	            muted = _props.muted,
	            loop = _props.loop,
	            autoPlay = _props.autoPlay,
	            controls = _props.controls,
	            playsInline = _props.playsInline;
	
	
	        return _react2.default.createElement(
	            "div",
	            { className: "background-video" },
	            _react2.default.createElement(
	                "video",
	                { controls: controls ? true : false,
	                    muted: muted ? true : false,
	                    loop: loop ? true : false,
	                    autoPlay: autoPlay ? true : false,
	                    playsInline: playsInline ? true : false },
	                _react2.default.createElement("source", { src: src, type: "video/mp4" })
	            )
	        );
	    };
	
	    return BackgroundVideo;
	}(_react.Component);
	
	exports.default = BackgroundVideo;
	module.exports = exports["default"];

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _BackgroundVideo = __webpack_require__(335);
	
	var _BackgroundVideo2 = _interopRequireDefault(_BackgroundVideo);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Testimonials = __webpack_require__(130);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _AdmissionsSignup = __webpack_require__(129);
	
	var _AdmissionsSignup2 = _interopRequireDefault(_AdmissionsSignup);
	
	var _Signup = __webpack_require__(70);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Fellows = __webpack_require__(296);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _gsap = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import gsap from 'gsap'
	// import {TweenMax, Power2, TimelineLite, TimelineMax, TweenLite} from "gsap/TweenMax"
	
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	
	    // import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
	    // require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	}
	
	var OurStory = function (_React$Component) {
	    _inherits(OurStory, _React$Component);
	
	    function OurStory(props) {
	        _classCallCheck(this, OurStory);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            mainVideoPlay: false
	        };
	        return _this;
	    }
	
	    OurStory.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.controller = new ScrollMagic.Controller();
	
	        this.setState({
	            controller: this.controller
	        });
	
	        var timeline = this.refs.timeline;
	        if (timeline) {
	            var blocks = Array.from(timeline.getElementsByClassName('block'));
	            var timelineIndicator = this.refs.timelineBar;
	            var TL = new _gsap.TimelineMax();
	
	            TL.to(timelineIndicator, 0.5, { height: timeline.clientHeight, ease: 'Linear' });
	
	            var timelineScroll = new ScrollMagic.Scene({
	                triggerElement: timeline,
	                triggerHook: 0.5,
	                duration: timeline.clientHeight * 1.15
	            })
	            // .setTween(TL)
	            .addTo(this.controller);
	
	            blocks.map(function (b, index) {
	                var activateSections = new ScrollMagic.Scene({
	                    triggerElement: b,
	                    triggerHook: 0.5
	                }).setClassToggle(b, 'show').addTo(_this2.controller);
	                // .addIndicators()
	            });
	        }
	    };
	
	    OurStory.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.state.controller.destroy(true);
	        this.controller.destroy(true);
	    };
	
	    OurStory.prototype.scrollTo = function scrollTo(id) {
	        this.refs[id].scrollIntoView({ behavior: 'smooth' });
	    };
	
	    OurStory.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props$data = this.props.data,
	            page = _props$data.page,
	            fellows = _props$data.fellows;
	
	        var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	        var pageData = this.props.pathContext.data;
	        var interestFormColor = 'Green';
	
	        // console.log('THE DATA == ', pageData);
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-redesign' },
	            _react2.default.createElement(
	                'section',
	                { className: 'hero', style: { maxHeight: '75vh', background: 'url(https://images.ctfassets.net/j91b9gwu8s3q/6EAGZc2dxlerOPcbta8xqt/f89297846b834d15300ed2fce630d760/Our-story-hero.jpg) center no-repeat', backgroundSize: 'cover' } },
	                _react2.default.createElement('div', { className: 'background' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'h2 color-white' },
	                        'Global Citizen Year is addressing our leadership crisis by changing',
	                        _react2.default.createElement('br', null),
	                        'the composition, operating system, and impact of our next generation leaders.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-page-navigation bg-grey capper', style: { transform: 'translateY(-50%)' } },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'flex' },
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('why-we-exist');
	                                    } },
	                                'Why We Exist'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('what-we-do');
	                                    } },
	                                'What We Do'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('our-vision');
	                                    } },
	                                'Our Vision'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing', style: { maxWidth: '900px', zIndex: '20', position: 'relative' }, ref: 'why-we-exist' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'pre-header color-orange font-bold' },
	                        'Why We Exist: The Challenge'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'h1 medium' },
	                        'The world is experiencing a crisis of leadership'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'h3' },
	                        'Our greatest challenges\u2014from pandemics and populism, to persistent racial injustice and our imminent climate crisis\u2014cannot be solved by one community, or country alone. The fate of humanity rests on our ability to collaborate across lines of difference; and while our lives are interconnected, our experiences are not.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing grid-2 grid-tablet-1 no-padding-top grid-gap-90' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item bg-grey quote-container' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'quote' },
	                            'My reason for hope in this time of peril\u2026 comes from those who demonstrate compassionate, competent, and courageous leadership. We need leaders who build bridges, not walls...who bring us together, and who transcend the politics of division.\u201D'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'quote-author' },
	                            'Darren Walker, President, Ford Foundation'
	                        ),
	                        _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6cdZ77K8Zjgf5jkt8pNR4Y/a62b1deed53474d7d2a2a7faccc907b6/darren-walker-president-ford-foundation.png', alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'font-bold' },
	                            'History shows that ideas don\u2019t change the world\u2014leaders do.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null)
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Almost all of our most celebrated social change leaders have one thing in common: at an early age, they were shaped by formative experiences proximate to the problems they\u2019re now solving.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'These experiences gave them the context, empathy and insight to see opportunities where others saw obstacles, and to work collaboratively to find shared solutions.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'Overcoming our shared, global challenges requires a critical mass of leaders who represent society\u2019s diversity, are equipped to work across lines of difference, and are committed to a purpose beyond themselves.'
	                        )
	                    )
	                ),
	                _react2.default.createElement('img', { src: '/images/yellow-strokes.png', alt: 'Blue stroke', className: 'redesign-strokes strokes-top-right-corner', style: { width: '450px', maxWidth: '45%', zIndex: '10' } })
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grid awards-grid standard-spacing' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item section-title' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'h3' },
	                            'Awards &',
	                            _react2.default.createElement('br', null),
	                            'Recognition'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/press/', className: 'hoverlink' },
	                            'See all News & Press'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item flex icon-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item added-padding' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/3nippSzeks6wDfAzecSSPu/b69afc9ead9d2f92b2c0d54aa61ff36e/NY_Times.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item added-padding' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/7dkx89JbpURAhfdZ4X2kXS/0ff6cdcc0b43442b4bd214231e643329/Aspen_Ideas_Festival.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item added-padding' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/3vxN98beM3yRpfXV8N3dYi/691fa2f6ef6bec598411bbd95c02d0e9/Chronicle_of_Higher_Ed.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/29eLuFkTy7H1ZTQud24Lu1/c3786e90b90efb3f5265d3e49ce3cb85/Fast_Company.png', alt: '', style: { width: '140px' } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item added-padding' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/4TE7FdHSrERpPGOjHROOVo/ba6a135b20f1550cb9b277ed7617cce4/Goldman_Sachs.png', alt: '', style: { width: '90px' } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item added-padding' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6A4U06SJVR6Pd1TNfHBVNb/03af948387f55fcb68e1ee5fe232a206/Outsides-_Best_Places_to_Work.png', alt: '', style: { width: '105px' } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/2Hb9TMHQxhSgB7A2YaiMpt/5c2e81f658780654b07d5362d38c4ac6/PBS_News_Hour.png', alt: '', style: { width: '75px' } })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'section-timeline-with-intro' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-block' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content standard-spacing', ref: 'what-we-do' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'offset-grid expanded' },
	                            _react2.default.createElement('div', { className: 'item spacer' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'item' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'pre-header color-orange font-bold' },
	                                    'What We Do: The Solution'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'h1 medium' },
	                                    'Global Citizen Year is pioneering a new educational pathway to launch the leaders our world needs now'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Our current educational paradigm is outdated and failing to create the leaders our world urgently needs. High school has become a high stakes game to get into college and most get to campus without a clear understanding of WHY they are there. ',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'font-bold' },
	                                        'In the U.S. just 3% of students report having a transformative experience in college'
	                                    ),
	                                    '. By equipping young leaders with empathy, agency and a global perspective, we\u2019re changing the inputs into higher education in order to dramatically improve the outcomes.'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('img', { src: '/images/yellow-strokes-new.png', alt: '', className: 'redesign-strokes strokes-middle-left', style: { width: '580px', maxWidth: '31%' } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-container', ref: 'timeline' },
	                    _react2.default.createElement('div', { className: 'progress-indicator', ref: 'timelineBar' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block grid-2 grid-tablet-1 grid-gap-90 no-padding-bottom' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/681DPqB0WicyXIggcgqZF3/987b11c99c51e4449f253a501431ef68/our-story-timeline-1.jpg', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing no-padding-bottom' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'color-orange font-bold' },
	                                        'Step 1'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'h3' },
	                                        'Recruit and Select'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Each year, we identify diverse young people with exceptional leadership potential: self-starting, driven, and influential among their peers. We intervene at the most formative age, when students have the maturity to leave home but have not yet fixed their values and identity.'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block grid-2 grid-tablet-1 grid-gap-90 no-padding-bottom' },
	                        _react2.default.createElement('div', { className: 'item' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'color-orange font-bold' },
	                                        'Step 2'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'h3' },
	                                        'Train and Transform'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Our programs\u2019 core components (curriculum, coaching, and a diverse cohort) shape future leaders\u2019 trajectories by influencing their values, identity, and sense of purpose.'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block grid-2 grid-tablet-1 grid-gap-90 no-padding-bottom' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing no-padding-top' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'color-orange font-bold' },
	                                        'Step 3'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'h3' },
	                                        'Launch'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Our alumni approach college and careers with agency, empathy, a global perspective, and a driving sense of purpose. Global Citizen Year is the foundation that shapes their life\u2019s choices and trajectory.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5Xk57KrFayS4nNARGcQHEw/c95499806a576ceeb08b3598bdfd9e90/33338395050_6998d470cf_k__3_.jpg', alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block bottom-spacer grid-2 grid-tablet-1 grid-gap-90' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'color-orange font-bold' },
	                                        'Step 4'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'h3' },
	                                        'Amplify'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Over time, we will unleash a critical mass of leaders who reflect society\u2019s diversity and are committed to advancing the greater good. Supported by our powerful and growing network, Global Citizen Year alumni will be a significant force in advancing human progress.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'item' })
	                    )
	                ),
	                _react2.default.createElement('img', { src: '/images/yellow-strokes-tall.png', alt: '', className: 'redesign-strokes strokes-bottom-right-corner' })
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-split-links standard-spacing capper' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'h3 uppercase' },
	                        'Our Experiences'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item flex' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5YIM7rvQ38Yd1RJNqMaVr2/d3ac34db0e7b03669973ae98303461e4/our-experience-link-academy.jpg', alt: '' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'headline-with-accent green font-bold L' },
	                                    'Global Citizen Year Academy'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/academy/', className: 'hoverlink' },
	                                    'Learn about the Academy'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item flex' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/4qu0SFemayAiU7rW8AzAfN/18e6714280a7ed1419aff24d7051156a/our-experience-link-fellowship.jpg', alt: '' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'headline-with-accent blue font-bold L' },
	                                    'Global Citizen Year Fellowship'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/fellowship/', className: 'hoverlink' },
	                                    'Learn about the Fellowship'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-black' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-partners-icon-container standard-spacing text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large text-center font-bold color-white' },
	                        'We are partnering with leading colleges and universities to leverage the',
	                        _react2.default.createElement('br', null),
	                        'resources of higher education, while influencing its evolution'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex icon-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/3m3BdNqK24wYkjgN4xszn5/7e4bcdb163cd9ac8044d63f8fdd1cc2d/logo1.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6mCk3KQ2MhHm4yWh8ztiIW/ae3cc11b84a2c7aaddcd649ff76e5d53/duke.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5XDaBED56EpRXCYI60aOcf/e8422677b53f84a9aad942696d28fcff/tufts.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6ivBejhjkADNoWI4VJnbRJ/f141483da6c0f8582ade7349c3affc80/UNC.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/4kAuTFAqpGzBhyGp8nqmYa/a65f94dd8690ac6b598f48cf8e9ebf38/notre-dame.png', alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(_Button2.default, {
	                        text: 'See All Partners',
	                        href: '/partners-and-supporters/',
	                        hoverwhite: true
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'standard-spacing no-padding-top no-padding-bottom remove-padding-tablet bg-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block quote-block standard-spacing text-center quote-color-black' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large color-black' },
	                        'Global Citizen Year is a bold new idea with the potential to have a significant impact over time. By harnessing the idealism of today\'s youth, Global Citizen Year will build a new force of leaders who will create lasting solutions to overcome poverty and inequity on a global scale.',
	                        '\u201D'
	                    ),
	                    _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/4Xwk9FcrHIhoIcyO0YXbm6/428513cf9d8ba15a968d9a05668c4e95/Wendy_Kopp_headshot_-_Juliana_Moreno_2.jpeg', className: 'headshot', alt: '' }),
	                    _react2.default.createElement('p', { className: 'credit mini color-black', dangerouslySetInnerHTML: { __html: 'Wendy Kopp,<br/>Founder of Teach For America and Teach For All' } })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-block' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content standard-spacing', ref: 'our-vision' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'pre-header font-bold color-orange' },
	                            'Our Vision'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'h1 medium', style: { maxWidth: '1200px' } },
	                            'A critical mass of leaders who bring curiosity, conviction and courage to overcoming our shared global challenges'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'offset-grid' },
	                            _react2.default.createElement('div', { className: 'item spacer' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'item' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'font-bold' },
	                                    'With a decade of proven impact, Global Citizen Year is at an inflection point.  In the next decade we aim to grow our impact and influence exponentially.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null)
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'By 2030 we\u2019ll train 10,000 young leaders annually: the same throughput as the Ivy League, with the same outsized influence on society.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    'Participation in Global Citizen Year will be a mark of distinction.  Colleges will provide preferred admissions, financial aid and academic credit for our alumni, and employers will clamor to higher them.  And as our alumni move into positions of influence\u2014as CEOs, journalists, senators or social entrepreneurs\u2014they\u2019ll drive solutions that create a more just, peaceful and sustainable world.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    'Beyond our direct impact, we\u2019re using our model as a proof-of-concept to catalyze a sea-change in our educational paradigm. By partnering with colleges, policy-makers and our own alumni we will ensure that, one day, a Global Citizen Year becomes a rite of passage and the hallmark of a world-class, higher education.'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('img', { src: '/images/yellow-strokes-new.png', alt: '', className: 'redesign-strokes strokes-bottom-right' })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-partners-icon-container standard-spacing text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large text-center font-bold' },
	                        'We are proud to work with a range of world-class partners who help us',
	                        _react2.default.createElement('br', null),
	                        'identify, train, and support our students'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex icon-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/NTd2hbC3B7yL6fwae5sXb/04a313a7916fb7cb13ac721f6096888d/College_Track.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/33bHBwJ9ZIgZA7PjbaZsn6/cf5da022580af93a758bf3728eab037c/Sunrise_Movement_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/1qdC4CQnZXA4A3CgzBhV6V/0300d70e9ef3fccb4920a6d8c5689f3f/Oxfam_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/73HEKrzKvob05a8Yg3Tu9P/61f2a3583c2d716bca34b35129d78695/Teach_For_India_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6v8sV2COqNDZZsAjw5vlET/8ad509d3b6299e7679d3d10f2a67c91e/Salesforce.org_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/4vK51BMi3PgXAfhrZtZVod/d642c39906ad964efb680a5fc07e33be/TED_Translate.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/5kD39sQdfkIstMV93suh3Y/baca141d6f9e4f0476f53e21ec825f22/Care.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/7495ZHlM2PcIYfqrVZqUvN/47144b213925d37ad94cbee5f4eb2fd0/Rosetta_Stone_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/3w4KuEpU1wccCWbOPEWRkj/4d1a24b2513dd7f6c61b848b275022c9/Gap_Year_Association_Copy.png', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6t7l5O0hWiPAbAZzczVRPp/ef14916aeff4e77b131e3fa4c2665789/UWC.png', alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(_Button2.default, {
	                        text: 'See All Partners',
	                        href: '/partners-and-supporters/#program-partners'
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'block-cta bg-dark-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content capper standard-spacing text-center' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'h1 text-center color-white' },
	                        'The Future is up to you'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'text-center color-white' },
	                        'Join our ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/partners-and-supporters/', className: 'color-orange' },
	                            'amazing community of donors'
	                        ),
	                        ' to launch the leaders the world needs now.',
	                        _react2.default.createElement('br', null),
	                        'Global Citizen Year is a 501c3, non-profit, and all contributions are fully tax-deductible.'
	                    ),
	                    _react2.default.createElement(_Button2.default, {
	                        text: 'Donate',
	                        href: '/donate/',
	                        hoverwhite: true
	                    })
	                )
	            )
	        );
	    };
	
	    return OurStory;
	}(_react2.default.Component);
	
	exports.default = OurStory;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-us-js-b767c561b164e76445c1.js